(() => {
  let loading = false;

  const loadNext = async () => {
    const trigger = document.querySelector('[data-infinite-next]');
    const grid = document.getElementById('product-grid');
    if (loading || !trigger || !grid) return;
    if (trigger.getBoundingClientRect().top > window.innerHeight * 2) return;

    loading = true;
    trigger.classList.add('is-loading');
    try {
      const url = new URL(trigger.dataset.infiniteNext, window.location.origin);
      url.searchParams.set('section_id', grid.dataset.id);
      const html = await (await fetch(url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = doc.querySelectorAll('#product-grid > .grid__item');
      items.forEach((item) => {
        item.classList.remove('scroll-trigger', 'animate--slide-in');
        grid.append(document.adoptNode(item));
      });
      const nextTrigger = doc.querySelector('[data-infinite-next]');
      if (nextTrigger) {
        trigger.dataset.infiniteNext = nextTrigger.dataset.infiniteNext;
      } else {
        trigger.remove();
      }
    } catch (error) {
      console.error(error);
    } finally {
      trigger.classList.remove('is-loading');
      loading = false;
      requestAnimationFrame(loadNext);
    }
  };

  let frame;
  const queue = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      loadNext();
    });
  };

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  document.addEventListener('DOMContentLoaded', queue);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
